import { render, staticRenderFns } from "./Lawyers.vue?vue&type=template&id=2bcb7044&"
import script from "./Lawyers.vue?vue&type=script&lang=js&"
export * from "./Lawyers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports